<template>
  <footer class="footer bg-gray-1">
    <div class="container py-4">
      <div v-if="$route.name !== 'loja-virtual-com-app' && $route.name !== 'cadastro-demo-lojista'" class="row align-items-center ml-5">
        <div class="col-5 col-md-2">
          <router-link
            class="d-block p-2 c-black c-orange-hover no-text-decoration"
            class-active="active"
            :to="{ name: 'home' }"
            v-if="this.$route.name !== 'home'"
          >
            <i class="fas fa-solid fa-warehouse mr-2 fs-16"> </i>Início
          </router-link>
          <div
            class="d-block p-2 c-pointer c-black c-orange-hover no-text-decoration"
            @click="toTop()"
            v-else
          >
            <i class="fas fa-solid fa-warehouse mr-2 fs-16"></i>
            Início
          </div>

          <router-link
            class="d-block p-2 c-black c-orange-hover no-text-decoration"
            class-active="active"
            :to="{ name: 'sobre' }"
          >
            <i class="fas fa-solid fa-book-open mr-2 fs-16"></i>
            Sobre</router-link
          >

          <router-link
            class="d-block p-2 c-black c-orange-hover no-text-decoration"
            class-active="active"
            :to="{ name: 'blog-geral' }"
          >
            <i class="fas fa-brands fa-blog mr-2 fs-18"></i>
            Blog</router-link
          >
          <router-link
            class="d-block p-2 c-black c-orange-hover no-text-decoration"
            class-active="active"
            :to="{ name: 'contato' }"
          >
            <i class="fas fa-solid fa-address-book mr-2 fs-18"></i>
            Contato</router-link
          >
        </div>
        <div class="col-7 col-md-3">
          <!-- <router-link
            class="d-block p-2 c-black c-orange-hover no-text-decoration"
            class-active="active"
            :to="{ name: 'quero-vender' }"
          >
            <i class="fas fa-solid fa-dolly mr-2 fs-20"></i>
            Quero vender</router-link
          > -->

          <router-link
            class="d-block p-2 c-black c-orange-hover no-text-decoration"
            class-active="active"
            :to="{ name: 'fazer-cotacao' }"
          >
            <i class="fas fa-tags mr-2 fs-16"></i>
            Fazer Orçamento</router-link
          >

          <router-link
            class="d-block p-2 c-black c-orange-hover no-text-decoration"
            class-active="active"
            :to="{ name: 'guia-profissionais-geral' }"
          >
            <i class="fas fa-hard-hat mr-2 fs-20"></i>
            Guia de Profissionais</router-link
          >

          <div
            class="d-block p-2 c-pointer c-black c-orange-hover no-text-decoration"
            @click="goToPages()"
          >
            <i class="fas fa-solid fa-user-lock mr-2 fs-16"></i>
            Área Restrita
          </div>
        </div>
        <div class="col-12 col-md-3 mt-5 mt-md-0">
          <span class="font-weight-bold">
            <p class="text-center">Baixe nosso App</p>
          </span>
          <div class="d-flex justify-content-around">
            <a
              class="store my-3"
              href="https://play.google.com/store/apps/details?id=br.com.construaja"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="fab fa-google-play fs-18"></i>
              Google Play
            </a>
            <a
              class="store my-3 ml-3"
              href="https://apps.apple.com/us/app/construa-j%C3%A1/id1492994116?l=pt&ls=1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="fab fa-apple fs-22"></i>
              App Store
            </a>
          </div>
        </div>
        <div class="col-12 col-md-4 mt-5 mt-md-0">
          <div class="mb-2">
            <a
              class="no-text-decoration c-black c-orange-hover"
              href="tel:+5519992065613"
            >
              <i class="fab fa-whatsapp mr-3 fs-26"></i>
              <span class="font-weight-bold fs-18">&nbsp;(19) 9 9206-5613</span> <br>
            </a>
              <i class="fas fa-phone-alt mr-3 fs-26"></i>
              <span class="font-weight-bold fs-18">&nbsp;(19) 3114-2472</span>
          </div>
          <div class="mb-2">
            <a
              class="c-black font-weight-bold c-orange-hover no-text-decoration"
              href="mailto:contato@construp.com.br"
            >
              <i class="fas fa-envelope mr-3 fs-24"></i>
              contato@construp.com.br
            </a>
          </div>
          <div class="fs-26">
            <a
              class="mr-4 c-black c-orange-hover"
              href="https://www.facebook.com/construpbr"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="fab fa-facebook"></i>
            </a>
            <a
              class="mr-4 c-black c-orange-hover"
              href="https://www.instagram.com/construpbr/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="fab fa-instagram"></i>
            </a>
            <a
              class="c-black c-orange-hover"
              href="https://www.youtube.com/channel/UCsd7TrWcsotvBl8FRakg6gQ"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="fab fa-youtube"></i>
            </a>
          </div>
        </div>
        <!-- <div class="col-3" v-if="checkIsEmpty(token)">
          <div class="box-login">
            <p class="mb-2">Acessar sua conta:</p>
            <form>
              <div class="form-row">
                <div class="col-12 p-0 mb-2">
                  <input
                    type="text"
                    v-model="login"
                    @keyup.enter="logar()"
                    class="form-control"
                    placeholder="E-mail, CPF ou CNPJ"
                  />
                </div>
                <div class="col-12 p-0 mb-2">
                  <input
                    type="password"
                    v-model="senha"
                    @keyup.enter="logar()"
                    class="form-control"
                    placeholder="Senha"
                  />
                </div>
                <button
                  type="button"
                  @click="logar()"
                  class="btn bg-orange c-white"
                >
                  Entrar
                </button>
              </div>
            </form>
          </div>
        </div> -->
      </div>


      <div v-if="$route.name === 'loja-virtual-com-app' || $route.name === 'cadastro-demo-lojista'" class="row d-flex justify-content-between">
          <div class="mb-2">
            <a
              class="no-text-decoration c-black c-orange-hover"
              href="tel:+5519992065613"
            >
              <i class="fab fa-whatsapp mr-3 fs-26"></i>
              <span class="font-weight-bold fs-18">&nbsp;(19) 9 9206-5613</span> <br>
            </a>
          </div>
        
          <div class="mb-2">
              <i class="fas fa-phone-alt mr-3 fs-26"></i>
              <span class="font-weight-bold fs-18">&nbsp;(19) 3114-2472</span>
          </div>
          
          <div class="mb-2">
            <a
              class="c-black font-weight-bold c-orange-hover no-text-decoration"
              href="mailto:contato@construp.com.br"
            >
              <i class="fas fa-envelope mr-3 fs-24"></i>
              contato@construp.com.br
            </a>
          </div>
          <div class="fs-26">
            <a
              class="mr-4 c-black c-orange-hover"
              href="https://www.facebook.com/construpbr"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="fab fa-facebook"></i>
            </a>
            <a
              class="mr-4 c-black c-orange-hover"
              href="https://www.instagram.com/construpbr/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="fab fa-instagram"></i>
            </a>
            <a
              class="c-black c-orange-hover"
              href="https://www.youtube.com/channel/UCsd7TrWcsotvBl8FRakg6gQ"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="fab fa-youtube"></i>
            </a>
          </div>
        </div>


      <hr class="mt-3 mb-4" />
      
      <div  class="row align-items-center">
        <div class="col-12 col-md-7">
          <div class="c-pointer d-flex justify-content-center">
            <router-link v-if="this.$route.name !== 'home'" to="/">
              <img
                class="w-190px"
                src="@/assets/img/Logo Novo ConstrUp.png"
                alt="Logo Constr Up"
              />
            </router-link>
            <img
              v-else
              class="w-190px"
              @click="toTop()"
              src="@/assets/img/Logo Novo ConstrUp.png"
              alt="Logo Constr Up"
            />
          </div>
          <div class="d-inline-block mt-2 mt-md-0 w-100"></div>
        </div>
        <div class="col-12 col-md-5 text-center text-md-right mt-3 mt-md-0">
          <p>
            <span class="font-weight-bold c-orange">Constr Up</span>
            - Todos os direitos reservados - <sup>©</sup>&nbsp; Copyright
            {{ this.getCurrentYear() }}
          </p>
          <router-link
            class="p-2 c-black c-orange-hover no-text-decoration"
            class-active="active"
            :to="{ name: 'termos' }"
          >
            Termos
          </router-link>
          |
          <router-link
            class="p-2 c-black c-orange-hover no-text-decoration"
            class-active="active"
            :to="{ name: 'privacidade' }"
          >
            Privacidade
          </router-link>
        </div>
      </div>
    </div>
    <!-- WHATSAPP FIXO NO FOOTER -->
    <a
      href="https://wa.me/5519992065613"
      id="btn-whatssap-edge"
      target="_blank"
      rel="noopener noreferrer"
      v-if="btnVerApp == false"
    >
      <!--WHATSAPP-->
      <a style="opacity: 1" id="ae_whats_btn" title="Converse conosco :)"
        ><i>1</i></a
      >
      <!--WHATSAPP-->
    </a>

    <div class="verAppBtn" v-if="btnVerApp == true" @click="veMeuApp()">
      <i class="fas fa-mobile mr-3 borderVerBtn"></i>
      <span>VER COMO MEU APP ESTÁ FICANDO</span>
    </div>


    <div class="tempoAppDemo" v-if="time != null">
      <span>TEMPO RESTANTE DE TESTE</span><br>
      <flip-countdown
        :deadline="time"
        countdownSize="1rem"
        labelSize=".7rem"
        :showDays="false"
        :labels="{
          days: 'Dias',
          hours: 'Hrs.',
          minutes: 'Min.',
          seconds: 'Seg.',
        }"
      >
      </flip-countdown>
    </div>
  </footer>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { setTimeout } from 'timers';
import FlipCountdown from 'vue2-flip-countdown';

export default {
  name: 'footer-login',
  components: {
    FlipCountdown
  },

  data: () => ({
    login: null,
    senha: null,
    scroll: true,
    btnVerApp: false,
    time: null
  }),

  beforeCreate() {
    this.$store.dispatch('loadToken');
  },

  watch: {
    '$route.name': function (n) {
      this.validTempo();
    }
  },

  created() {
    this.validTempo();
  },

  methods: {
    validTempo() {      
      this.time = null;    
      if(this.dadosUsuario !== undefined && this.dadosUsuario !== null && this.dadosUsuario.tipo_usuario_id == 3) {

        if(this.dadosUsuario.informacoes && this.dadosUsuario.informacoes.solicita_app && this.dadosUsuario.informacoes.solicita_app.status != 2) {
          this.btnVerApp = true;
        }

        const dateNow = Date.now();
        const dateClockDemo = new Date(this.dadosUsuario.informacoes.demo_app);
        const dateEndDemo = dateClockDemo.getTime();
        
        if(this.dadosUsuario.informacoes && this.dadosUsuario.informacoes.demo_app && this.dadosUsuario.informacoes.demo_app != null) {
          this.time = this.dadosUsuario.informacoes.demo_app;
          if(dateEndDemo < dateNow) {
            this.updateStatusDemoApp(this.dadosUsuario.informacoes.id)
          }
        }else if(this.$route.name !== "lojista-cartão-credito-app-ass" && 
          this.dadosUsuario.informacoes.solicita_app && 
          this.dadosUsuario.informacoes.solicita_app.status === 2) {
          this.$router.push({ name: 'lojista-assinatura-app-site' });
        }
      } else {
        this.btnVerApp = false;
      }
    },
    updateStatusDemoApp(idShopkeeper) {
      const data = {
        id : idShopkeeper
      }
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/updateStatusDemo', data).then (() =>{
          let dadosUsuarioBck = this.dadosUsuario;
          dadosUsuarioBck.informacoes.demo_app = null;
          dadosUsuarioBck.informacoes.solicita_app.status = 2;
          localStorage.removeItem('dadosUsuario');
          localStorage.setItem('dadosUsuario', JSON.stringify(dadosUsuarioBck));
          this.$router.push({ name: 'lojista-assinatura-app-site' });
        });
    },

    getCurrentYear() {
      return new Date().getFullYear();
    },
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    veMeuApp() {
      this.$router.push({ name: 'lojista-ver-app' });
    },
    logar() {
      const self = this;
      const data = {
        email: this.login,
        password: this.senha,
      };
      if (data.email !== null && data.senha !== null) {
        this.$store
          .dispatch('loadLogin', data)
          .then(() => {
            setTimeout(() => {
              if (this.getTipoNotification === 1) {
                this.aviso(this.getNotification, 'success');
              } else if (this.getTipoNotification === 3) {
                this.aviso(this.getNotification, 'danger');
              }
              if (self.dadosUsuario !== null) {
                if (self.dadosUsuario.tipo_usuario === 'Cliente') {
                  self.$router.push({ name: 'cliente-meus-dados' });
                } else if (self.dadosUsuario.tipo_usuario === 'Lojista') {
                  self.$router.push({ name: 'lojista-meus-dados' });
                } else if (self.dadosUsuario.tipo_usuario === 'Profissional') {
                  self.$router.push({ name: 'profissional-meus-dados' });
                } else if (self.dadosUsuario.tipo_usuario === 'Representante') {
                  self.$router.push({ name: 'representante-meus-dados' });
                } else if (self.dadosUsuario.tipo_usuario === 'Editor') {
                  self.$router.push({ name: 'editor-meus-dados' });
                } else if (self.dadosUsuario.tipo_usuario === 'Administrador') {
                  self.$router.push({ name: 'administrador-meus-dados' });
                }
              }
              this.$store.dispatch('endLoader');
            }, 1000);
          })
          .catch((error) => {
            self.aviso(error.response.data.message, 'danger');
          });
      } else {
        self.aviso(
          'É necessário que você digite algo nos dois campos!',
          'warning'
        );
      }
    },
    desabilitado() {
      this.aviso(
        "É necessário que você clique no 'entrar' para logar!",
        'warning'
      );
    },
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    goToPages() {
      if (!this.checkIsEmpty(this.dadosUsuario)) {
        if (this.dadosUsuario.tipo_usuario === 'Cliente') {
          this.$router.push({ name: 'cliente-meus-dados' });
        } else if (this.dadosUsuario.tipo_usuario === 'Lojista') {
          this.$router.push({ name: 'lojista-meus-dados' });
        } else if (this.dadosUsuario.tipo_usuario === 'Profissional') {
          this.$router.push({ name: 'profissional-meu-perfil' });
        } else if (this.dadosUsuario.tipo_usuario === 'Representante') {
          this.$router.push({ name: 'representante-meus-dados' });
        } else if (this.dadosUsuario.tipo_usuario === 'Administrador') {
          this.$router.push({ name: 'administrador-meus-dados' });
        } else if (this.dadosUsuario.tipo_usuario === 'Editor') {
          this.$router.push({ name: 'editor-meus-dados' });
        }
      } else {
        this.$router.push({ name: 'cadastro' });
      }
    },
    toTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
  computed: {
    ...mapGetters(['getToken', 'getTipoNotification', 'getNotification']),
    ...mapState(['token', 'dadosUsuario']),
  },
};
</script>

<style>
.tempoAppDemo {
  position: fixed;
  background-color: #222;
  color: #FFF;
  right: 20px;
  bottom: 10px;
  text-align: center;
  padding: 5px 30px;
  border-radius: 4px;
  z-index: 9;
}
.verAppBtn {
  position: fixed;
  background-color: #222;
  color: #FFF;
  right: 20px;
  bottom: 90px;
  text-align: center;
  padding: 15px 30px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}
.borderVerBtn {
  font-size: 28px;
}
.store {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
  font-size: 1.2em;
  color: #000;
  width: 140px;
  padding: 5px;
  border: 2px solid #000;
  border-radius: 30px;
}

.store:hover {
  color: var(--orange-primary) !important;
  border-color: var(--orange-primary);
  text-decoration: none;
}
</style>
